import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LoginForm from './login/LoginForm.js';
import SetRoleForm from './login/SetRoleForm.js';
import AuthContextProvider from './AuthContextProvider';
import PrivateRoute from './PrivateRoute';
import Home from './Home';
import HeaderAppBar from './HeaderAppBar';
import MOTDList from './motd/MOTDList';
import MOTD from './motd/MOTD.js';
import EventList from './event/EventList.js';
import Event from './event/Event.js';
import UploadVideo from './event/UploadVideo.js';
import CreateEvent from './event/CreateEvent.js';
import ScheduledEventList from './scheduledEvent/ScheduledEventList.js';
import ScheduledEventAdminList from './scheduledEvent/ScheduledEventAdminList.js';
import ScheduledEvent from './scheduledEvent/ScheduledEvent.js';
import UserList from './user/UserList.js';
import User from './user/User.js';
import GroupList from './group/GroupList.js';
import Group from './group/Group.js';
import PhotoList from './photo/PhotoList.js';
import UploadPhotos from './photo/UploadPhotos.js';
import TodaysScheduledEventList from './today/TodaysScheduledEventList.js';
import VideoConferenceEvent from './today/VideoConferenceEvent.js';
import BingoEvent from './today/BingoEvent.js';
import VideoEvent from './today/VideoEvent.js';
import SiteList from './site/SiteList.js';
import Site from './site/Site.js';
import SiteAdminList from './siteAdmin/SiteAdminList.js';
import SiteAdmin from './siteAdmin/SiteAdmin.js';
import Usage from './usage/Usage.js';
import ChangeUserDetails from './user/ChangeUserDetails.js';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import ClassList from "./classes/ClassList";
import ClassDetails from './classes/ClassDetails';
import ZoomNow from './user/ZoomNow.js';

const itvsTheme = createTheme({
  palette: {
    primary: {
      main: "#196ac4"
    },
    secondary: {
      main: "#24D15F"
    }
  }
});

const App = () => {
  return (
    <ThemeProvider theme={itvsTheme}>
      <Router>
        <AuthContextProvider>
          <HeaderAppBar />
          <Routes>
            {/* Public Route */}
            <Route path="/login" element={<LoginForm />} />

            {/* All Protected Routes */}
            <Route element={<PrivateRoute />}>
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/setRole" element={<SetRoleForm />} />

              {/* MOTD Routes */}
              <Route path="/motds" element={<MOTDList />} />
              <Route path="/createMotd" element={<MOTD />} />
              <Route path="/motd/:id" element={<MOTD />} />

              {/* Event Routes */}
              <Route path="/events" element={<EventList />} />
              <Route path="/event/:id" element={<Event />} />
              <Route path="/uploadVideo" element={<UploadVideo />} />
              <Route path="/createEvent/:type" element={<CreateEvent />} />

              {/* Scheduled Event Routes */}
              <Route path="/scheduledEvents" element={<ScheduledEventList />} />
              <Route path="/scheduledEvent/:id" element={<ScheduledEvent />} />
              <Route path="/createScheduledEvent" element={<ScheduledEvent />} />

              {/* Class Routes */}
              <Route path="/classes" element={<ClassList />} />
              <Route path="/classDetails/:id" element={<ClassDetails />} />
              <Route path="/createClass" element={<ClassDetails />} />

              {/* User Routes */}
              <Route path="/users" element={<UserList />} />
              <Route path="/user/:id" element={<User />} />
              <Route path="/createUser" element={<User />} />
              <Route path="/updateUser" element={<ChangeUserDetails />} />
              <Route path="/zoom" element={<ZoomNow />} />

              {/* Group Routes */}
              <Route path="/groups" element={<GroupList />} />
              <Route path="/group/:id" element={<Group />} />
              <Route path="/createGroup" element={<Group />} />

              {/* Photo Routes */}
              <Route path="/photos" element={<PhotoList />} />
              <Route path="/uploadPhotos" element={<UploadPhotos />} />

              {/* Today / Interactive Routes */}
              <Route path="/today" element={<TodaysScheduledEventList />} />
              <Route path="/videoConferenceEvent/:id" element={<VideoConferenceEvent />} />
              <Route path="/bingoEvent/:id" element={<BingoEvent />} />
              <Route path="/videoEvent/:id" element={<VideoEvent />} />

              {/* Site & Admin Routes */}
              <Route path="/sites" element={<SiteList />} />
              <Route path="/site/:id" element={<Site />} />
              <Route path="/createSite" element={<Site />} />
              <Route path="/usage" element={<Usage />} />
              <Route path="/globalUsage" element={<Usage allSites />} />
              <Route path="/siteAdmins" element={<SiteAdminList />} />
              <Route path="/siteAdmin/:id" element={<SiteAdmin />} />
              <Route path="/createSiteAdmin" element={<SiteAdmin />} />
              <Route path="/siteEvents" element={<ScheduledEventAdminList />} />
            </Route>
          </Routes>
        </AuthContextProvider>
      </Router>
    </ThemeProvider>
  );
};

export default App;